module.exports = __webpack_public_path__ + "img/Icon-warning.15ab6246.svg";